import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    itemscope: "",
    itemtype: "http://schema.org/Product",
    class: "microdata"
};
const _hoisted_2 = ["content"];
const _hoisted_3 = ["content"];
const _hoisted_4 = ["content"];
const _hoisted_5 = ["content"];
const _hoisted_6 = ["content"];
const _hoisted_7 = ["content"];
const _hoisted_8 = ["content"];
const _hoisted_9 = {
    itemprop: "offers",
    itemscope: "",
    itemtype: "http://schema.org/Offer"
};
const _hoisted_10 = ["content"];
const _hoisted_11 = ["content"];
const _hoisted_12 = ["content"];
const _hoisted_13 = { class: "container-fluid bg-white" };
const _hoisted_14 = { class: "container px-sm-3 px-0 pt-sd-45 pt-3" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = {
    key: 0,
    class: "col-md-6"
};
const _hoisted_17 = { class: "container-fluid bg-brand_beige_light" };
const _hoisted_18 = { class: "container px-sm-3 px-0" };
const _hoisted_19 = { class: "container-fluid bg-white" };
const _hoisted_20 = { class: "container px-sm-3 px-0" };
const _hoisted_21 = { class: "container-fluid bg-brand_beige_background" };
const _hoisted_22 = { class: "container px-sm-3 px-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const _component_breadcrumb_nav = _resolveComponent("breadcrumb-nav");
    const _component_image_gallery_desktop = _resolveComponent("image-gallery-desktop");
    const _component_info_pills = _resolveComponent("info-pills");
    const _component_product_headline = _resolveComponent("product-headline");
    const _component_image_gallery_mobile = _resolveComponent("image-gallery-mobile");
    const _component_artikelnummer_trustpilot_stueckzahl = _resolveComponent("artikelnummer-trustpilot-stueckzahl");
    const _component_price_cta_and_infos = _resolveComponent("price-cta-and-infos");
    const _component_filter_box = _resolveComponent("filter-box");
    const _component_benefits_list = _resolveComponent("benefits-list");
    const _component_kontakt_info = _resolveComponent("kontakt-info");
    const _component_gebrauchte_geraete_verkaufen = _resolveComponent("gebrauchte-geraete-verkaufen");
    const _component_product_description = _resolveComponent("product-description");
    const _component_emarsys_recos = _resolveComponent("emarsys-recos");
    const _component_sticky_cta_button = _resolveComponent("sticky-cta-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("span", _hoisted_1, [
            _createElementVNode("meta", {
                itemprop: "image",
                content: (_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.mainImage
            }, null, 8, _hoisted_2),
            _createElementVNode("meta", {
                itemprop: "sku",
                content: (_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.id
            }, null, 8, _hoisted_3),
            _createElementVNode("meta", {
                itemprop: "gtin13",
                content: (_c = _ctx.currentProduct) === null || _c === void 0 ? void 0 : _c.ean
            }, null, 8, _hoisted_4),
            _createElementVNode("meta", {
                itemprop: "ItemCondition",
                content: ((_d = _ctx.currentProduct) === null || _d === void 0 ? void 0 : _d.condition) === 1000 ? 'new' : 'used'
            }, null, 8, _hoisted_5),
            _createElementVNode("meta", {
                itemprop: "brand",
                content: (_e = _ctx.currentProduct) === null || _e === void 0 ? void 0 : _e.manufacturer
            }, null, 8, _hoisted_6),
            _createElementVNode("meta", {
                itemprop: "name",
                content: (_f = _ctx.currentProduct) === null || _f === void 0 ? void 0 : _f.name
            }, null, 8, _hoisted_7),
            _createElementVNode("meta", {
                itemprop: "description",
                content: (_g = _ctx.currentProduct) === null || _g === void 0 ? void 0 : _g.shortDescription
            }, null, 8, _hoisted_8),
            _createElementVNode("span", _hoisted_9, [
                _createElementVNode("meta", {
                    itemprop: "price",
                    content: (_h = _ctx.currentProduct) === null || _h === void 0 ? void 0 : _h.currentPrice
                }, null, 8, _hoisted_10),
                _createElementVNode("meta", {
                    content: 'http://schema.org/' + (((_j = _ctx.currentProduct) === null || _j === void 0 ? void 0 : _j.stock_available) > 1 ? 'InStock' : 'SoldOut')
                }, null, 8, _hoisted_11),
                _cache[0] || (_cache[0] = _createElementVNode("meta", {
                    itemprop: "priceCurrency",
                    content: "EUR"
                }, null, -1)),
                _createElementVNode("meta", {
                    itemprop: "url",
                    content: (_k = _ctx.currentProduct) === null || _k === void 0 ? void 0 : _k.link
                }, null, 8, _hoisted_12)
            ])
        ]),
        _createVNode(_component_breadcrumb_nav),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                    (!_ctx.isMobile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_image_gallery_desktop)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: _normalizeClass([{ 'col-md-6': !_ctx.isMobile }, { 'col-12': _ctx.isMobile }])
                    }, [
                        _createVNode(_component_info_pills),
                        _createVNode(_component_product_headline),
                        (_ctx.isMobile)
                            ? (_openBlock(), _createBlock(_component_image_gallery_mobile, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_artikelnummer_trustpilot_stueckzahl),
                        _createVNode(_component_price_cta_and_infos),
                        (_ctx.currentProduct)
                            ? (_openBlock(), _createBlock(_component_filter_box, { key: 1 }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_benefits_list),
                        _createVNode(_component_kontakt_info)
                    ], 2)
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_gebrauchte_geraete_verkaufen)
            ])
        ]),
        _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_product_description)
            ])
        ]),
        _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_emarsys_recos, { headline: "Das könnte dir auch gefallen" })
            ])
        ]),
        _createVNode(_component_sticky_cta_button)
    ], 64));
}
